import {AdminTeachersTable} from './AdminTeachersTable';

export default AdminTeachersTable;
